const API_URL = process.env.REACT_APP_BACKEND_URL;

export async function initiatePayUPayment({ token, purpose, amount, orderId }) {
  const res = await fetch(`${API_URL}/api/payu/initiate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ purpose, amount: amount ? parseFloat(amount) : undefined, order_id: orderId })
  });
  const data = await res.json();
  if (!res.ok) {
    throw new Error(data.detail || 'Failed to start PayU payment');
  }
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = data.action;
  Object.entries(data.fields).forEach(([key, value]) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = key;
    input.value = value ?? '';
    form.appendChild(input);
  });
  document.body.appendChild(form);
  form.submit();
}
